import { emailLogActionTypes } from "src/types/actionTypes";
import { ErrorAction, SuccessAction } from "src/types/responseTypes";
import { EmailLogList,EmailLog } from "src/types/emailLogTypes";

export type emailLogAction = SuccessAction<EmailLogList> | SuccessAction<EmailLog> | SuccessAction<any> | ErrorAction
export const defaultCountryState: EmailLogList = { emailLog:{}, data: [],loading:true, metadata: {},redirectTo:"" };

const reducer = (state: EmailLogList = defaultCountryState, action: emailLogAction): EmailLogList => {
    switch (action.type) {
        case emailLogActionTypes.EMAIL_LOG_REQUEST:
            state = { ...state, loading:true }
            return state
        case emailLogActionTypes.FETCH_EMAIL_LOG_SUCCESS:
            action = <SuccessAction<EmailLogList>>action
            state = { ...state, data: action.payload.data,loading:false,metadata:action.payload.metadata }
            return state
        case emailLogActionTypes.FETCH_EMAIL_LOG_COUNT_SUCCESS:
            action = <SuccessAction<EmailLogList>>action
            state = { ...state, data: action.payload,loading:false }
            return state
        case emailLogActionTypes.EMAIL_LOG_FAILURE:
            action = <ErrorAction>action
            return { ...state }
        default:
            return state
    }
}

export default reducer